export default {
  new_tag: 'Novità',
  groups: {
    dashboards: 'Dashboard',
    online_shop: 'Negozio online',
    home: 'Home',
    marketing: 'Marketing',
    reservations: 'Prenotazioni',
    website: 'Sito web',
    orders_portal: 'Avvia portale ordini',
    roi: 'ROI',
    google_ads: 'Google Ads',
    mobile_app: 'App Mobile',
    phone_answering: 'Risposta Telefonica',
    pricing: 'Prezzi',
    team: 'Team',
    data_deletion_requests: 'Richieste di cancellazione dati',
    partner: 'Partner',
  },
  get_started: {
    title: 'Inizia',
  },
  onboarding: {
    title: 'Avvio',
  },
  new_restaurant: {
    title: 'Nuovo ristorante',
  },
  gift_cards: {
    title: 'Gift Card',
  },
  top_items: {
    title: 'Articoli Top',
  },
  dashboards: {
    title: 'Dashboard',
    children: {
      general: 'Generale',
      restaurant_details: 'Dettagli Ristorante',
      external_delivery: 'Consegna Esterna',
      overview: 'Panoramica',
      orders: 'Ordini per fonte',
      google: 'Google',
      customers: 'Clienti',
    },
  },
  customer_base: {
    title: 'Base Clienti',
  },
  new_company: {
    title: 'Nuovo ristorante',
  },
  agent_ops_queue: {
    title: 'Suggerimenti AI',
  },
  external_delivery_support: {
    title: 'Supporto consegna esterna',
  },
  payment_gateways: {
    title: 'Gateway di Pagamento',
  },
  developers: {
    title: 'Sviluppatori',
  },
  feature_flags: {
    title: 'Feature Flag',
  },
  platform_agent_log: {
    title: 'Log di Amigo',
  },
  test_restaurants: {
    title: 'Ristoranti di test',
  },
  partners: {
    title: 'Partner',
  },
  partner: {
    children: {
      account: 'Account',
      branding: 'Branding',
      payment_gateway: 'Gateway di pagamento',
      billing: 'Fatturazione',
      tax_currency: 'Tasse e valuta',
      service_fee_calculator: 'Calcolatore commissione di servizio',
      processing_fees: 'Commissioni di elaborazione',
    },
  },
  going_live: {
    title: 'Messa in produzione',
    children: {
      setup_package_fulfillments: 'Evasioni Logsta',
      polygraphy: 'Prodotti Stampa',
    },
  },
  franchises: {
    title: 'Marchi',
  },
  setup_package_fulfillments: {
    title: 'Evasioni pacchetto setup',
  },
  website: {
    title: 'Sito web',
    children: {
      storefront: 'Vetrina',
      studio: 'Studio (V1)',
      studio_v2: 'Studio (V2)',
    },
  },
  reservations: {
    title: 'Prenotazione',
    children: {
      overview: 'Panoramica',
      booking_availability: 'Disponibilità Prenotazioni',
      settings: 'Impostazioni',
      general: 'Generale',
      storefront: 'Vetrina',
    },
  },
  subscriptions: {
    title: 'Abbonamenti',
    children: {
      subscriptions: 'Abbonamenti',
      products: 'Prodotti',
    },
  },
  sales: {
    title: 'Vendite',
    children: {
      orders: 'Ordini',
      receipts: 'Ricevute clienti',
      external_deliveries: 'Consegne esterne',
    },
  },
  billing: {
    title: 'Report',
    children: {
      monthly_statements: 'Estratti Mensili',
      payouts: 'Pagamenti',
      invoices: 'Fatture',
      subscription: 'Abbonamento',
      sales_summary: 'Riepilogo vendite',
      internal_invoice_items: 'Voci fattura interne',
      income_reports: 'Report entrate',
      tax_reports: 'Report fiscali',
    },
  },
  master_menu: {
    title: 'Sincronizzazione marchio',
  },
  menu: {
    title: 'Menu',
    children: {
      master_overview: 'Marchi',
      manage_menus: 'Gestisci menu',
      modifiers: 'Modificatori',
      smart_pricing: 'Prezzi dinamici',
      upsell_items: 'Articoli upsell',
      sold_out_items: 'Articoli esauriti',
      import: 'Importa',
      edit_history: 'Cronologia modifiche',
    },
  },
  my_store: {
    title: 'Le mie info',
    children: {
      settings: 'Profilo',
      gallery: 'Galleria',
      business_information: 'Informazioni Aziendali',
      documents: 'I miei documenti',
      personal_information: 'Informazioni Personali',
      bank_info: 'Coordinate Bancarie',
      tax_info: 'Dati Fiscali',
      shipping_info: 'Dati di Spedizione',
      google_profile: 'Profilo Google',
      seo: 'SEO',
      impressum: 'Note Legali',
      imprint: 'Note legali',
      post_launch: 'Post-Lancio',
      tax_currency: 'Tasse e valuta',
    },
  },
  opening_hours: {
    title: 'Orari di apertura e Posizione',
    children: {
      opening_hours: 'Orari di apertura',
      location: 'Posizione',
    },
  },
  order_settings: {
    title: 'Impostazioni ordini',
    children: {
      takeout: 'Metodi di Ordine',
      missed_orders: 'Ordini persi',
      order_layout: 'Layout Ordine',
      payment_methods: 'Metodi di pagamento',
      connect_paypal: 'Collega PayPal',
      tips: 'Mance',
      service_fee: 'Commissioni',
      processing_fees: 'Commissioni di elaborazione',
      receipt: 'Ricevuta',
      staff_credentials: 'Credenziali staff',
      integrations: 'Integrazioni',
      terminal: 'Terminale',
      invoices: 'Fatture',
    },
  },
  mobile_app: {
    title: 'App Mobile',
    children: {
      overview: 'Panoramica',
      updates: 'Aggiornamenti',
      intro_screen: 'Schermata Iniziale',
    },
  },
  marketing: {
    children: {
      overview: 'Panoramica',
      followers: 'Follower',
      email_messages: 'Messaggi email',
      push_notifications: 'Notifiche push',
      promo_codes: 'Codici promo',
      offers: 'Offerte',
      google_business: 'Google Business',
      google_review_program: 'Programma recensioni Google',
      loyalty_program: 'Programma fedeltà',
      polygraphy: 'Prodotti Stampa',
      tracking_links: 'Link di Tracciamento',
      google_ads: 'Google Ads',
      website_analytics: 'Analytics Sito Web',
      featured_posts: 'Post App Mobile',
    },
  },
  loyalty_tablet: {
    title: 'Tablet Fedeltà',
    children: {
      dashboard: 'Dashboard',
      settings: 'Impostazioni',
      credentials: 'Credenziali',
    },
  },
  contract: {
    title: 'Contratto',
    children: {
      agreement: 'Accordo',
      template: 'Modello',
    },
  },
  team: {
    children: {
      managers: 'Manager',
      reports: 'Report',
    },
  },
};
